// src/theme/tokens.typography.ts

export const typography = {
  fontFamily: '"Open Sans", sans-serif',

  // HEADERS
  h1: {
    regular: { fontSize: '48px', fontWeight: 400 },
    semibold: { fontSize: '48px', fontWeight: 600 },
    bold: { fontSize: '48px', fontWeight: 700 },
  },
  h2: {
    regular: { fontSize: '40px', fontWeight: 400 },
    semibold: { fontSize: '40px', fontWeight: 600 },
    bold: { fontSize: '40px', fontWeight: 700 },
  },
  h3: {
    regular: { fontSize: '36px', fontWeight: 400 },
    semibold: { fontSize: '36px', fontWeight: 600 },
    bold: { fontSize: '36px', fontWeight: 700 },
  },
  h4: {
    regular: { fontSize: '32px', fontWeight: 400 },
    semibold: { fontSize: '32px', fontWeight: 600 },
    bold: { fontSize: '32px', fontWeight: 700 },
  },
  h5: {
    regular: { fontSize: '28px', fontWeight: 400 },
    semibold: { fontSize: '28px', fontWeight: 600 },
    bold: { fontSize: '28px', fontWeight: 700 },
  },
  h6: {
    regular: { fontSize: '24px', fontWeight: 400 },
    semibold: { fontSize: '24px', fontWeight: 600 },
    bold: { fontSize: '24px', fontWeight: 700 },
  },

  // SUBTITLES
  subtitle1: {
    regular: { fontSize: '16px', fontWeight: 400 },
    semibold: { fontSize: '16px', fontWeight: 600 },
    bold: { fontSize: '16px', fontWeight: 700 },
  },
  subtitle2: {
    regular: { fontSize: '14px', fontWeight: 400 },
    semibold: { fontSize: '14px', fontWeight: 600 },
    bold: { fontSize: '14px', fontWeight: 700 },
  },

  // CAPTION
  caption: {
    regular: { fontSize: '12px', fontWeight: 400 },
    semibold: { fontSize: '12px', fontWeight: 600 },
    bold: { fontSize: '12px', fontWeight: 700 },
  },

  // BODY
  body1: {
    regular: { fontSize: '16px', fontWeight: 400 },
    semibold: { fontSize: '16px', fontWeight: 600 },
    bold: { fontSize: '16px', fontWeight: 700 },
  },
  body2: {
    regular: { fontSize: '14px', fontWeight: 400 },
    semibold: { fontSize: '14px', fontWeight: 600 },
    bold: { fontSize: '14px', fontWeight: 700 },
  },
  body3: {
    regular: { fontSize: '12px', fontWeight: 400 },
    semibold: { fontSize: '12px', fontWeight: 600 },
    bold: { fontSize: '12px', fontWeight: 700 },
  },

  // BUTTON
  button: {
    regular: { fontSize: '16px', fontWeight: 700 }, // Bold según Figma
  },

  // BUTTON SMALL
  buttonSmall: {
    regular: { fontSize: '12px', fontWeight: 700 },
  },

  // OVERLINE
  overline: {
    regular: { fontSize: '10px', fontWeight: 600 },
  },
} as const;

export default typography;
